import { Stack } from '@mui/material';

import Input from './input';
import InputDate from './input-date';
import InputTime from './input-time';
import { useCreateContext } from './provider';
import { StyledContainer, StyledNotes, StyledTypography } from './styles.css';

function MailSettings() {
  const { state, error, onDispatch } = useCreateContext();

  return (
    <StyledContainer sx={{mt: 4}}>
      <StyledTypography style={{fontSize: 20, fontWeight: 700, color: "black"}} >Start and Draw Date</StyledTypography>
      <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} gap="3rem" >
        <Stack sx={{ width: "48%" }}>
          <InputDate label="Start Date:" 
            sx={{ gap: 2, alignItems: "center", justifyContent: "center" }}
            value={state.startAt}
            onChange={onDispatch("startAt")}
            inputSx={{
              width: "100%",
              '& .MuiInputBase-root': {
                width: "100%",
                border: error.startAt ? "1px solid red" : "",
                borderRadius: "4px",
                height: "50px",
              },
            }} />
          <StyledNotes >*Start date - entries open on this date</StyledNotes>
        </Stack>
        <Stack sx={{ width: "48%" }}>
          <Input
            sx={{ width: "100%", display: "flex", flexDirection: "row", gap: 2, alignItems: "center" }}
            placeholder="0"
            inputSx={{
              '& .MuiInputBase-root': {
                height: '50px',
              },
              }}
            label="Ticket Price:" 
            type="number"
            error={error.ticketPrice}
            value={state.ticketPrice}
            onChange={onDispatch("ticketPrice")} />
          <StyledNotes >*Amount of Palms Gold required per raffle ticket</StyledNotes>
        </Stack>
        
      </Stack>
      <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} gap="3rem" >
        <Stack sx={{ width: "48%" }}>
          <InputDate label="Draw Date:" 
            sx={{ gap: 2, alignItems: "center", justifyContent: "center" }}
            value={state.drawAt}
            onChange={onDispatch("drawAt")}
            inputSx={{
              width: "100%",
              '& .MuiInputBase-root': {
                width: "100%",
                border: error.drawAt ? "1px solid red" : "",
                borderRadius: "4px",
                height: "50px",
              },
            }} />
          <StyledNotes >*Draw date - choose when the draw takes place</StyledNotes>
        </Stack>
        <Stack sx={{ width: "48%" }}>
          <Input
            sx={{ width: "100%", display: "flex", flexDirection: "row", gap: 2, alignItems: "center" }}
            placeholder="0"
            inputSx={{
              '& .MuiInputBase-root': {
                height: '50px',
              },
              }}
            label="Ticket Limit:" 
            type="number"
            error={error.ticketLimit}
            value={state.ticketLimit}
            onChange={onDispatch("ticketLimit")} />
          <StyledNotes >*Amount of raffle tickets allowed per person</StyledNotes>
        </Stack>
      </Stack>
      <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"} gap="3rem" >
        <Stack sx={{ width: "48%" }}>
          <InputTime label="Set time:" 
            sx={{ gap: 2, alignItems: "center", justifyContent: "center" }}
            value={state.drawTime}
            onChange={onDispatch("drawTime")}
            inputSx={{
              width: "100%",
              '& .MuiInputBase-root': {
                width: "100%",
                border: error.drawTime ? "1px solid red" : "",
                borderRadius: "4px",
                height: "50px",
              },
            }} />
          <StyledNotes >*Set Time - Specify the exact time of the draw</StyledNotes>
        </Stack>
        <Stack sx={{ width: "48%" }}>
          <Input
            sx={{ width: "100%", display: "flex", flexDirection: "row", gap: 2, alignItems: "center" }}
            placeholder="0"
            inputSx={{
              '& .MuiInputBase-root': {
                height: '50px',
              },
              }}
            label="# of Winners:" 
            type="number"
            error={error.numWinners}
            value={state.numWinners}
            onChange={onDispatch("numWinners")} />
          <StyledNotes >*Number of winners required for this draw</StyledNotes>
        </Stack>
        
      </Stack>
    </StyledContainer>
  );
}

export default MailSettings;